import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import dashboard from "./dashboardReducer";
import loginReducer from "./loginReducer";
import userManagement from "./userManagement";
import tenantManagement from "./tenantManagement";
import rbacManagement from "./rbacManagement";
import resourceManager from "./resourceManager";
import machineCatalog from "./machineCatalog";
import machineCatalogue from "./machineCatalogue";
import myLabsReducer from "./myLabs";
import userMachineCatalog from "./userMachineCatalog";
import common from "./common";
import notificationManagement from "./notificationManagement";
import requestManager from "./requestManager";
import actionLogs from "./actionLog";
import headerNotification from "./headerNotification";
import notificationsReducer from "./notifications";
import portalWalkthrough from "./portalWalkthrough";
import notificationSettingsReducer from "./notificationSettings";
import usage from "./usage";
import workspaceManager from "./workspaceManager";
import userWorkspaceManager from "./userWorkspaceManager";
import helpReducer from "./help";
import directLabLogin from "./directLoginReducer";
import vmInsight from "./vmInsightReducer";
import invoices from "./invoices";
import b2c from "./b2c";
import resellerLicense from "./resellerLicense";
import customReportsReducer from "./customReportsReducer";
import layoutReducer from "./UIReducer";
import publicResourceManager from "./publicResourceManagerReducer";

const MainReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    dashboard: dashboard,
    userAuthentication: loginReducer,
    userManagement: userManagement,
    tenantManagement: tenantManagement,
    rbacManagement: rbacManagement,
    resourceManager: resourceManager,
    machineCatalog: machineCatalog,
    machineCatalogue: machineCatalogue,
    myLabsReducer: myLabsReducer,
    userMachineCatalog: userMachineCatalog,
    common: common,
    notificationManagement: notificationManagement,
    requestManager: requestManager,
    actionLogs: actionLogs,
    headerNotification: headerNotification,
    notificationsReducer: notificationsReducer,
    portalWalkthrough: portalWalkthrough,
    notificationSettingsReducer: notificationSettingsReducer,
    usage: usage,
    workspaceManager: workspaceManager,
    userWorkspaceManager: userWorkspaceManager,
    help: helpReducer,
    directLabLogin: directLabLogin,
    vmInsight: vmInsight,
    invoices: invoices,
    b2c: b2c,
    resellerLicense: resellerLicense,
    customReports: customReportsReducer,
    layout: layoutReducer,
    publicResourceManager: publicResourceManager,
  });

export default MainReducer;
